import { createActionCreator } from "common/ReduxUtils";
import { StorageInboundDetailActionTypes } from "../StorageInboundDetailStore.types";

export const resetStorage = createActionCreator(StorageInboundDetailActionTypes.RESET_STORAGE_DETAILS);
